module.exports = __webpack_public_path__ + "img/books.0eb306af.svg";